<template>
  <div>
    <div class="row" v-if="signedSession">
      <div
        class="col s12 m12 l6 animated zoomInLeft"
        id="leftContainment"
        :class="[
          windows.width >= 1200 ? 'l6' : 'l6',
          windows.width >= 600 && windows.width <= 900 ? 'm12' : 'm6'
        ]"
        :style="[
          windows.width >= 1200 ? 'display: block' : 'display: block',
          windows.width >= 600 && windows.width <= 910
            ? 'display: none'
            : 'display: block'
        ]"
      >
        <div class="card-panel hoverable" :class="{ blur: proccedBtn }">
          <h5>Data Subscriptions</h5>
          <form @submit.prevent="verifyDataInfo" id="form">
            <div class="row">
              <div class="input-field col s12 m12">
                <select
                  v-model="fields.network"
                  @change="getBundles(fields.network)"
                >
                  <option value="" disabled selected>Select option</option>
                  <option value="MTN">MTN</option>
                  <option value="Glo">GLO</option>
                  <option value="Etisalat">Etisalat</option>
                  <option value="Airtel">Airtel</option>
                  <option value="Smile">Smile</option>
                  <option value="Spectranet">Spectranet (PIN)</option>
                </select>
                <label>Select Network</label>
              </div>
            </div>
            <div class="row" id="bundleSelect">
              <div class="col s12 m12">
                <label class="pull-left">Select Bundles</label>
                <select
                  v-model="fields.service_id"
                  class="browser-default"
                  id="bundleDropdown"
                >
                  <option value="" disabled selected>Select option</option>
                  <option
                    v-for="(item, index) in bundles"
                    :key="index"
                    :value="item.code"
                    >{{ item.title }}</option
                  >
                </select>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input id="receiver" type="text" v-model="fields.receiver" />
                <label
                  for="receiver"
                  v-if="
                    fields.network == 'Spectranet' || fields.network == 'Smile'
                  "
                  >Account Number</label
                >
                <label for="receiver" v-else>Reciever Number</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <input id="email" type="email" v-model="fields.email" />
                <label for="email">Email Address</label>
              </div>
              <div class="input-field col s12 m6">
                <input id="phone" type="text" v-model="fields.phone" />
                <label for="phone" class="active">Phone Number</label>
              </div>
            </div>
            <div class="row">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div class="col s12 m12" v-else>
                <button
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  :disabled="proccedBtn"
                >
                  <i class="material-icons right">send</i>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        class="col s12 m12 l6"
        id="rightContainment"
        :class="[
          windows.width >= 1200 ? 'l6' : 'l6',
          windows.width >= 600 && windows.width <= 900 ? 'm12' : 'm6'
        ]"
      >
        <transition name="slide-fade">
          <div v-if="showSummary" class="card-panel z-depth-3">
            <h5>Transaction Summary</h5>
            <table class="highlight">
              <tbody>
                <tr v-show="fields.network == 'Smile'">
                  <th>Customer Name</th>
                  <td>{{ custName }}</td>
                </tr>
                <tr>
                  <th v-if="fields.network == 'Smile'">Device Number</th>
                  <th v-else>Reciever Number</th>
                  <td>{{ fields.receiver }}</td>
                </tr>
                <tr>
                  <th>Network</th>
                  <td>
                    {{ fields.network }}
                    <img
                      :src="getImage(fields.network)"
                      class="responsive-img"
                      width="30px"
                      style="vertical-align: middle; float: right"
                    />
                  </td>
                </tr>
                <tr>
                  <th>Amount</th>
                  <td>{{ fields.amount }}</td>
                </tr>
                <tr>
                  <th>Phone Number</th>
                  <td>{{ fields.phone }}</td>
                </tr>
                <tr>
                  <th>Email Address</th>
                  <td>{{ fields.email }}</td>
                </tr>
                <tr>
                  <th>Payment method</th>
                  <td>
                    <select
                      class="browser-default"
                      id="payoption"
                      v-model="payment_option"
                    >
                      <option value="" disabled selected
                        >Choose your option</option
                      >
                      <option value="1">Pay with Card</option>
                      <option value="2">Pay with Voucher</option>
                      <option value="3">Pay with USSD</option>
                      <option value="4">Pay with Bank Transfer</option>
                      <option value="5">Pay with Wallet</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row" v-show="proccedBtn">
              <div class="col s12 m12" style="margin-top: 15px">
                <div v-if="vending">
                  <img src="ui/img/loading.svg" alt="Time Loader" />
                  <p><i>Loading...</i></p>
                </div>
                <div v-else>
                  <div class="right">
                    <a
                      class="waves-effect waves-light btn-small"
                      @click="payOption(payment_option)"
                      >Pay</a
                    >
                  </div>
                  <a
                    class="waves-effect waves-light btn-small left"
                    @click="revert"
                    >Back</a
                  >
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Voucher Modal Structure -->
      <div id="voucher" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
          <img src="ui/img/logo.png" width="18%" class="responsive-img" />
        </div>
        <div class="modal-content">
          <form>
            <h5>Enter Voucher Code</h5>
            <div class="row">
              <div class="input-field col s12 m8 offset-s2 offset-m2">
                <input
                  placeholder="Voucher Code"
                  id="voucher_code"
                  type="text"
                  v-model="voucher_code"
                />
              </div>
            </div>
            <div class="row" v-if="vouching">
              <div class="col s4 offset-s4 m4 offset-m4">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
            </div>
            <div class="row" v-else>
              <a
                class="waves-effect waves-light btn-small"
                type="submit"
                @click="verifyVoucher"
                >Redeem Voucher</a
              >
            </div>
          </form>
        </div>
      </div>
      <!-- Voucher Modal Structure -->
      <ussd-code
        :transactionID="transactionID"
        :coralCode="coralpayCode"
        :service="service"
        @ussd-complete="ussdComplete"
      />
      <!-- Bank Transfer Modal Structure -->
      <bank-transfer
        :transactionID="transactionID"
        :amount="fields.amount"
        :details="generateDetails"
        :service="service"
        @ussd-complete="ussdComplete"
      />
      <!-- Bank Transfer Modal Structure -->
      <!-- Vending Status Modal Structure -->
      <div id="vendStatus" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
        </div>
        <div class="modal-content">
          <div class="feedbackForm" v-if="!feedback">
            <div v-if="successModal">
              <img
                src="ui/img/success.png"
                width="12%"
                class="responsive-img"
              />
              <h6>Your order has been completed sucessfully.</h6>
            </div>
            <div v-if="!successModal">
              <img src="ui/img/failed.png" width="12%" class="responsive-img" />
              <h6>Order was not sucessful.</h6>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <h6><strong>Transaction Details</strong></h6>
                <p><strong>Transaction Ref:</strong> {{ transactionID }}</p>
                <p>
                  <strong>{{
                    fields.network == 'Smile' || fields.network == 'Spectranet'
                      ? 'Account Number:'
                      : 'Reciever Number'
                  }}</strong>
                  {{ fields.receiver }}
                </p>
                <p><strong>Payment Reference:</strong> {{ payment_ref }}</p>
                <p v-if="fields.network == 'Spectranet'">
                  <strong>Other Information:</strong> {{ spectranetPin }}
                </p>
              </div>
              <div class="col s12 m6">
                <h6><strong>Customer Details</strong></h6>
                <p v-show="fields.network == 'Smile'">
                  <strong>Customer Name:</strong> {{ custName }}
                </p>
                <p>
                  <strong>Email:</strong>
                  {{ fields.email == '' ? 'Not provided' : fields.email }}
                </p>
                <p><strong>Phone</strong> {{ fields.phone }}</p>
              </div>
            </div>
            <hr style="width: 65%" />
            <div v-show="!feedbackSuccess && successModal">
              <div class="row">
                <div class="col s12 m6">
                  <h6><strong>How was your experience?</strong></h6>
                  <a
                    href="#"
                    @click.prevent="
                      feedback = true
                      feedbackfield.satisfaction = true
                      feedbackfield.recommend = true
                    "
                  >
                    <img
                      class="feedbackEmoji"
                      src="ui/img/happyface.png"
                      style="margin-right: 10px"
                    />
                  </a>
                  <a
                    href="#"
                    @click.prevent="
                      feedback = true
                      feedbackfield.satisfaction = false
                      feedbackfield.recommend = false
                    "
                  >
                    <img class="feedbackEmoji" src="ui/img/sadface.png" />
                  </a>
                </div>
                <div class="col s12 m6 l6">
                  <h6><strong>Share with a friend</strong></h6>
                  <i
                    @click="whatsApp"
                    class="fa fa-whatsapp"
                    style="font-size: 37px; cursor: pointer; color: #008000; margin-right: 15px"
                  ></i>
                  <!-- <i @click="whatsApp" class="fa fa-facebook" style="font-size: 37px; cursor: pointer; color: #0b0b77"></i> -->
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row" style="clear: both; padding: 15px 0px 10px">
            <button class="btn-small" @click="createAccount('signup')">Create Account</button>
          </div> -->
          <div class="feedbackForm" v-if="feedback">
            <h5 style="margin-bottom: 40px">Customer feedback form</h5>
            <form @submit.prevent="sendFeedback">
              <div class="row">
                <div class="col s6 m6">
                  <div class="switch">
                    <strong>Are you satisfied with the service:</strong> <br />
                    <label>
                      No
                      <input
                        type="checkbox"
                        v-model="feedbackfield.satisfaction"
                      />
                      <span class="lever"></span>
                      Yes
                    </label>
                  </div>
                </div>
                <div class="col s6 m6">
                  <div class="switch">
                    <strong>Would you recommend irecharge to a friend: </strong
                    ><br />
                    <label>
                      No
                      <input
                        type="checkbox"
                        v-model="feedbackfield.recommend"
                      />
                      <span class="lever"></span>
                      Yes
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m10 offset-m1">
                  <textarea
                    class="materialize-textarea comment"
                    data-length="120"
                    maxlength="120"
                    v-model="feedbackfield.comment"
                  ></textarea>
                  <label for="textarea2">Comment</label>
                </div>
              </div>
              <div class="row" v-if="feedbackloading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div class="row" style="margin-bottom: 50px" v-else>
                <a
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  @click="feedback = false"
                  style="margin-right: 10px"
                  >No Thanks</a
                >
                <a
                  class="waves-effect waves-light btn-small"
                  type="submit"
                  @click="sendFeedback"
                  >Send Feedback</a
                >
              </div>
            </form>
          </div>
          <p style="clear:both">
            <img src="ui/img/thanks.png" width="21%" class="responsive-img" />
          </p>
        </div>
      </div>
      <!-- Vending Status Modal Structure -->
      <!-- Wallet Modal Structure -->
      <div id="wallet" class="modal services">
        <div class="modal-header">
          <a class="modal-close waves-effect btn-small waves-green right">x</a>
        </div>
        <div class="modal-content">
          <form>
            <h5 style="margin: 30px">Verify Wallet Debit</h5>
            <div class="row">
              <div class="input-field col s12 m8 offset-s2 offset-m2">
                <input
                  id="wallet_username"
                  type="text"
                  v-model="wallet_username"
                />
                <label for="email_phone" class="active"
                  >Email/Phone number</label
                >
              </div>
              <div
                class="input-field col s12 m8 offset-s2 offset-m2"
                v-if="reveal == true"
              >
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility_off</i
                >
                <input id="pass" type="text" v-model="wallet_password" />
                <label for="pass" class="active">Password</label>
              </div>
              <div
                class="input-field col s12 m8 offset-s2 offset-m2"
                v-if="reveal == false"
              >
                <i
                  class="material-icons prefix"
                  @click="visibility"
                  style="cursor: pointer;"
                  >visibility</i
                >
                <input
                  id="password"
                  type="password"
                  v-model="wallet_password"
                />
                <label for="password" class="active">Password</label>
              </div>
            </div>
            <div class="row" v-if="walletProcess">
              <div class="col s4 offset-s4 m4 offset-m4">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
            </div>
            <div class="row" v-else>
              <a
                class="waves-effect waves-light btn-small"
                type="submit"
                @click="verifyWallet"
                >Validate</a
              >
            </div>
          </form>
        </div>
      </div>
      <!-- Wallet Modal Structure -->
      <create-account :attempt="updateAttempt" />
      <!-- Card details Modal Structure Number 8-->
      <card-response
        @otherCard="proceedWithNewCard"
        :cardDetails="retrieveCard"
        :loading="vending"
        @chargeCard="chargeCard"
      />
      <!-- Save Card details Modal Structure Number 9-->
      <save-card @saveCard="saveCard" />
    </div>
    <div v-else>
      <welcome @modal-option="selectedView" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import BankTransfer from '@/components/modals/BankTransfer.vue'
import UssdCode from '@/components/modals/UssdCode.vue'
import Welcome from "@/components/partials/Welcome.vue"
import CreateAccount from "@/components/modals/CreateAccount.vue"
import CardResponse from "@/components/modals/CardResponse.vue"
import SaveCard from "@/components/modals/SaveCard.vue"
export default {
  name: 'Data',
  metaInfo: {
    // all titles will be injected into this template
    titleTemplate: '%s | Data Subscription',
    meta: [
      { name: 'description', content: 'iRecharge.com.ng  Subscribe for your MTN, EITSALAT, AIRTEL, SMILE, SPECTRANET, GLO Data Online Easily with iRecharge' },
      { name: 'keywords', content: 'Buy airtime online, buy MTN airtime, buy internet data subscription, Etisalat Glo Airtel Airtime, DSTV payment, DSTV subscription, GOTV payment, PHCN payment, Login to iRecharge, Buy MTN Airtime, Glo Etisalat Airtel Airtime, Internet Data subscription, GOTV DSTV startimes payment, buy airtime online, online data, smile subscription, online data recharge, buy data online, airtel data, glo data,  Airtel VTU,  Smile Data Purchase, Spectranet Data Subscription, Smile Data Subscription' },
    ]
  },
  components: {
    BankTransfer,
    UssdCode,
    CreateAccount,
    Welcome,
    CardResponse,
    SaveCard
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if(localStorage.getItem('phone') !== null) {
      if(sessionStorage.getItem('status') === null) {
        // localStorage.setItem('userType', 2)
        if(localStorage.getItem('userType') != "2" || localStorage.getItem('userType') != "1") {
          this.signedSession = true
        } else {
          this.signedSession = false
        }
      } else {
        this.signedSession = true
      }
    } else {
      this.signedSession = false
    }
  },
  mounted() {
    // initialize modal for the document
    this.initModal()
    $('#bundleSelect').hide()
    $('.bills__side__wrapper').removeClass('left_out')
    if(localStorage.getItem('data') !== null) {
      this.fields.phone = localStorage.getItem('phone')
      $('#phone').val(this.fields.phone)
      var data = JSON.parse(localStorage.getItem('data'));
      if(data.message === "Successful") { // if the transaction isn't empty for the user
        this.fields.receiver = data.receiver
        $('#receiver').val(this.fields.receiver)
        this.fields.phone = data.phone
        $('#phone').val(this.fields.phone)
        this.fields.email = data.email
        $('#email').val(this.fields.email)
      }
    } else {
      this.fields.phone = localStorage.getItem('phone')
      $('#phone').val(this.fields.phone)
    }
    if(localStorage.getItem('username') != '' && localStorage.getItem('username') != null && localStorage.getItem('username') != undefined){
      this.fields.username = localStorage.getItem('username')
    }
    $('select').formSelect()
    this.wallet_username = this.fields.phone
    M.updateTextFields()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  data() {
    return {
      reveal: false,
      signedSession: false,
      mode: 2,
      appkey_test: 'pk_test_ad8895a4fe6b5f196b62a1a34a6c044addddbae1',
      appkey_live: 'pk_live_909a2c23b75ae6c5a442c9fe8ef4c634e7aac8d2',
      windows: {
        width: 0,
        height: 0
      },
      fields: {
        "amount": "",
        "source":"iRecharge",
        "category":"iRecharge",
        "username":"",
        "platform":"Website",
        "d_uuid":"12345",
        "d_platform":"Website",
      },
      bundles: [],
      feedback: false,
      feedbackSuccess: false,
      feedbackloading: false,
      feedbackfield: {
        "service":"data"
      },
      proccedBtn: false,
      showSummary: false,
      modalInstance: {},
      mobileView: false,
      loading: false,
      payment_option: '',
      custName: '',
      totalAmount: '',
      transactionID: '',
      payment_ref: '',
      payment_option: '',
      voucher_code: '',
      payment_method: '',
      ussdoption: '',
      vending: false,
      vouching: false,
      successModal: false,
      service: 'data',
      generateDetails: {
        type: false,
        bank: 'GT Bank',
        account_name: 'IRECHARGE TECH-INNOVATIONS LTD',
        account_number: '0460540637'
      },
      spectranetPin: '',
      wallet_username: '',
      wallet_password: '',
      walletProcess: false,
      updateAttempt: '',
      retrieveCard: {},
      reusable: false,
      coralpayCode: ''
    }
  },
  methods: {
    selectedView(option) {
      this.$emit('modal-option', option)
    },
    visibility() {
      this.reveal = !this.reveal
    },
    verifyWallet() {
      if(this.ValidateWalletData()) {
        this.reveal = false
        this.walletProcess = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', 'login')
        bodyFormData.set('action', 'login')
        bodyFormData.set('inputEmail', this.wallet_username)
        bodyFormData.set('inputPassword', this.wallet_password)
        this.axios.post('control1.php', bodyFormData)
        .then(response => {
          if(response.data.status == 1) {
            $('.toast').hide()
            M.toast({ html: 'Verification Successful, Please wait while we vend...', classes: 'success' })
            let obj = {
              "transaction_id": this.transactionID,
              "payment_ref": this.transactionID,
              "payment_method": this.payment_method,
              "voucher_code": this.voucher_code,
              "user_numid": response.data.userid
            }
            obj.passcode = this.hash(this.transactionID)
            this.axios.post('https://irecharge.com.ng/api/data/vend.php', obj)
            .then(response => {
              if(response.data.status == "0") {
                this.successModal = true
                this.revert()
                // this.emptyFormInputs()
                this.disableFormInputs(false)
                this.payment_ref = response.data.payment_ref
                if(this.fields.network == 'Spectranet') {
                  this.spectranetPin = response.data.pin
                }
                this.modalInstance[4].close() // close wallet payment modal
                this.modalInstance[3].open() // transaction successful modal
                this.walletProcess = false
                this.updateStorage(
                  this.fields.phone, 
                  this.fields.email,
                  this.fields.receiver
                )
                $('.toast').hide()
                M.toast({ html: 'Your subscription will be ACTIVE shortly.', classes: 'success' })
              } else {
                this.proccedBtn = true
                $('.toast').hide()
                M.toast({ html: response.data.message, classes: 'error' })
                this.walletProcess = false
              }
            })
            .catch(error => {
              $('.toast').hide()
              M.toast({ html: 'Could not send request, check network.', classes: 'error' })
              this.walletProcess = false
            })
          } else {
            this.walletProcess = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.walletProcess = false
        })
      }
    },
    proceedWithNewCard() {
      this.modalInstance[6].close()
      this.PayStack()
    },
    retrieveCardDetails() {
      this.vending = true
      let obj = {
        "username": this.fields.username
      }
      obj.passcode = this.hash(obj.username.toString())
      this.axios.post('https://irecharge.com.ng/api/card/retrieve.php', obj)
        .then(response => {
          if(response.data.status == "0") {
            this.retrieveCard = response.data
            this.modalInstance[6].open()
          } else {
            this.PayStack()
          }
          if (response.data.message == "Unauthorized Access") {
            $('.toast').hide()
            M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.vending = true
        })
    },
    saveCard(option) {
      this.reusable = false
      this.modalInstance[7].close()
      let obj = {
        "username": this.fields.username,
        "response": option
      }
      obj.passcode = this.hash(obj.username.toString())
      this.axios.post('https://irecharge.com.ng/api/card/save.php', obj)
        .then(response => {
          if(response.data.status == "0") {
            M.toast({ html: response.data.message, classes: 'success' })
          } else {
            M.toast({ html: response.data.message, classes: 'info' })
          }
          if (response.data.message == "Unauthorized Access") {
            $('.toast').hide()
            M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        })
    },
    chargeCard(password) {
      // verify the user password
      this.vending = true
      // set form data
      var bodyFormData = new FormData()
      bodyFormData.set('relocate', 'login')
      bodyFormData.set('action', 'login')
      bodyFormData.set('inputEmail', this.wallet_username)
      bodyFormData.set('inputPassword', password)
      this.axios
        .post('control1.php', bodyFormData)
        .then(response => {
          if (response.data.status == 1) {
            this.modalInstance[6].close()
            this.vending = true
            let obj = {
              username: localStorage.getItem('username') ? localStorage.getItem('username') : this.fields.username,
              amount: this.fields.amount,
              last4: this.retrieveCard.last4
            }
            obj.passcode = this.hash(obj.username.toString())
            M.toast({ html: 'Please wait, while we charge the card.', classes: 'info' })
            this.axios.post('https://irecharge.com.ng/api/card/charge.php', obj)
              .then(response => {
                if(response.data.status == "0") {
                  this.payment_ref = response.data.payment_ref
                  M.toast({ html: 'Card successfully charged, vending in progress', classes: 'success' })
                  this.vendData()
                } else {
                  M.toast({ html: 'We could not charge the selected card, redirecting to paystack in 3sec...', classes: 'info' })
                  setTimeout(() => {
                    $('.toast').hide()
                    this.PayStack()
                  }, 3000);
                }
                if (response.data.message == "Unauthorized Access") {
                  $('.toast').hide()
                  M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
                }
                this.vending = false
              })
              .catch(error => {
                $('.toast').hide()
                M.toast({ html: 'Could not send request, check network.', classes: 'error' })
                this.vending = false
              })
          } else {
            this.vending = false
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.vending = false
        })
    },
    ValidateWalletData() {
      if (this.wallet_username != '') {
        if (this.wallet_password != '') {
          return true
        } else {
          $('.toast').hide()
          M.toast({ html: 'Password is required', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Email/Phone number is required', classes: 'info' })
      }
    },
    createAccount(option) {
      this.$emit('modal-option', option)
      document.getElementById('myNav').style.width = '100%'
      this.modalInstance[3].close()
    },
    whatsApp() {
      window.open('https://api.whatsapp.com/send?phone=&text=Hello!%20I%27ve%20just%20made%20some%20transactions%20seamlessly%20right%20now.%20Try%20it%20out%20here,%20you%27ll%20enjoy%20their%20service%20https://irecharge.ng', '_blank');
    },
    getBundles(network) {
      document.getElementById('bundleDropdown').disabled = true
      let obj = {
        "network": this.fields.network,
      }
      obj.passcode = this.hash(this.fields.network)
      $('.toast').hide()
      M.toast({ html: 'Fetching bundle, Please wait...', classes: 'info' })
      this.axios.post('https://irecharge.com.ng/api/data/bundles.php', obj)
      .then(response => {
        if(response.data.status == "0") {
          this.bundles = response.data.bundles
          $('.toast').hide()
          M.toast({ html: 'Kindly select a bundle', classes: 'info' })
          $('#bundleSelect').show()
          document.getElementById('bundleDropdown').disabled = false
        } else {
          $('.toast').hide()
          M.toast({ html: response.data.message, classes: 'error' })
        }
      })
      .catch(error => {
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.vouching = false
      })
    },
    handleResize() {
      this.windows.width = window.innerWidth
      this.windows.height = window.innerHeight
    },
    disableFormInputs(option) {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.disabled = option
      })
      formSelect.forEach(function(item) {
        item.disabled = option
      })
    },
    setParameters() {
      // sets the parameters of the customer
      this.fields.d_model = window.navigator.vendor
      this.fields.d_name = window.navigator.vendor
    },
    payOption(option) {
      if(option == '') {
        $('.toast').hide()
        M.toast({ html: 'Kindly select payment option', classes: 'info' })
      } else {
        if(option == '1') { // Card payment option
          this.payment_method = 'Card'
          if(this.fields.username != "") {
            // check if card details exist
            this.retrieveCardDetails()
          } else {
            this.PayStack()
          }
        }
        if(option == '2') { // Voucher payment option
          this.payment_method = 'Voucher'
          this.modalInstance[0].open()
        }
        if(option == '3') { // USSD code payment option
          this.service = 'data'
          this.generateUSSDCode()
        }
        if(option == '4') { // Bank transfer payment option
          this.generateBank()
        }
        if(option == '5') { // Wallet payment option
          this.payment_method = 'Wallet'
          this.modalInstance[4].open()
        }

        try{ 
        __adroll.track("pageView", {"segment_name":"cbb9972f"}) 
        } catch(err) {}
        
      }


    },
    generateUSSDCode() {
      this.vending = true
      let obj = {}
      obj.transaction_id = this.transactionID
      obj.service = this.service
      obj.passcode = this.hash(obj.transaction_id)
      this.axios.post('https://irecharge.com.ng/api/coralpay/generate.php', obj)
        .then(response => {
          if(response.data.status == "0") {
            this.coralpayCode = response.data.code
            this.modalInstance[1].open()
          } else {
            $('.toast').hide()
            M.toast({ html: 'Error generating code, click "PAY" again', classes: 'error' })
          }
          if (response.data.message == "Unauthorized Access") {
            this.disableFormInputs(false)
            $('.toast').hide()
            M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.vending = false
        })
    },
    generateBank() {
      this.vending = true
      let obj = {}
      obj.transaction_id = this.transactionID
      obj.service = this.service
      obj.passcode = this.hash(this.transactionID)
      this.axios.post('https://irecharge.com.ng/api/teamapt/generate.php', obj)
        .then(response => {
          if(response.data.status == "0") {
            this.generateDetails.account_name = response.data.account_name
            this.generateDetails.account_number = response.data.account_number
            this.generateDetails.bank = response.data.bank
            this.generateDetails.type = true
            this.modalInstance[2].open()
          } else {
            this.generateDetails.account_name = response.data.account_name
            this.generateDetails.account_number = response.data.account_number
            this.generateDetails.bank = response.data.bank
            this.modalInstance[3].open()
          }
          if (response.data.message == "Unauthorized Access") {
            this.disableFormInputs(false)
            $('.toast').hide()
            M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
          }
          this.vending = false
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({ html: 'Could not send request, check network.', classes: 'error' })
          this.vending = false
        })
    },
    sendFeedback() {
      this.feedbackloading = true
      let obj = {
        recommend: '',
        satisfaction: '',
        service: this.feedbackfield.service,
        transaction_id: this.transactionID,
        comment: this.feedbackfield.comment
      }
      if(this.feedbackfield.recommend) {
        obj.recommend = "yes"
      } else {
        obj.recommend = "no"
      }
      if(this.feedbackfield.satisfaction) {
        obj.satisfaction = "yes"
      } else {
        obj.satisfaction = "no"
      }
      obj.passcode = this.hash(this.transactionID)
      this.axios.post('https://irecharge.com.ng/api/feedback/submit.php', obj)
      .then(response => {
        if(response.data.status == "0") {
          this.feedbackloading = false
          this.feedback = false
          this.feedbackSuccess = true
          $('.toast').hide()
          M.toast({ html: 'Feedback received', classes: 'success' })
        } else {
          this.feedbackloading = false
          $('.toast').hide()
          M.toast({ html: response.data.message, classes: 'info' })
        }
      })
      .catch(error => {
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.vouching = false
      })
    },
    verifyVoucher() {
      if(this.payment_method == 'Voucher') {
        if(this.voucher_code == '') {
          $('.toast').hide()
          M.toast({ html: 'Kindly enter your voucher code', classes: 'info' })
        } else {
          this.vouching = true
          let obj = {
            "transaction_id": this.transactionID,
            "payment_ref": this.transactionID,
            "payment_method": this.payment_method,
            "voucher_code": this.voucher_code,
          }
          obj.passcode = this.hash(this.transactionID)
          this.axios.post('https://irecharge.com.ng/api/data/vend.php', obj)
          .then(response => {
            if(response.data.status == "0") {
              this.successModal = true
              this.revert()
              // this.emptyFormInputs()
              this.disableFormInputs(false)
              this.payment_ref = response.data.payment_ref
              if(this.fields.network == 'Spectranet') {
                this.spectranetPin = response.data.pin
              }
              this.modalInstance[3].open() // transaction succeful modal
              this.modalInstance[0].close()
              this.vouching = false
              this.updateStorage(
                this.fields.phone, 
                this.fields.email,
                this.fields.receiver
              )
              $('.toast').hide()
              M.toast({ html: 'Your subscription will be ACTIVE shortly.', classes: 'success' })
            } else {
              this.proccedBtn = true
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'error' })
              this.vouching = false
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({ html: 'Could not send request, check network.', classes: 'error' })
            this.vouching = false
          })
        }
      }
    },
    verifyDataInfo() {
      if (this.ValidateData()) { // Validate information on form
        this.loading = true
        this.setParameters() // set the device name and model
        this.fields.passcode = this.hash(this.fields.receiver.toString())
        this.axios.post('https://irecharge.com.ng/api/data/verify.php', this.fields)
          .then(response => {
            if(response.data.status == "0") {
              this.transactionID = response.data.transaction_id
              // sets the customer information
              this.custName = response.data.customer
              this.fields.amount = response.data.amount
              this.proccedBtn = true
              // Show modal with Customer Information
              this.verifiedSmartCard()
              $('.toast').hide()
              // M.toast({ html: 'Kindly verify smart card information', classes: 'success' })
              if (this.windows.width <= 900) {
                const formInput = document.querySelector('#leftContainment')
                formInput.style.display = 'none'
              }
              if (this.windows.width >= 1200) {
                this.mobileView = true
              }
            } else {
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
            if (response.data.message == "Unauthorized Access") {
              $('.toast').hide()
              M.toast({ html: 'We could not verify, please try again.', classes: 'error' })
            }
            this.loading = false
            this.disableFormInputs(false)
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({ html: 'Could not send request, check network.', classes: 'error' })
            this.loading = false
            this.disableFormInputs(false)
          })
      }
    },
    verifiedSmartCard() {
      // proceeds to summary if agreed
      if (this.windows.width <= 900) {
        const formInput = document.querySelector('#leftContainment')
        formInput.style.display = 'none'
      }
      if (this.windows.width >= 1200) {
        this.mobileView = true
      }
      this.proccedBtn = true
      this.showSummary = true
      // display the create account modal
      if(localStorage.getItem('user') == "false") {
        if(localStorage.getItem('attempts') <= "1") {
          this.modalInstance[5].open()
          this.updateAttempt = localStorage.getItem('attempts')
          localStorage.setItem('attempts', 0)
        }
      }
    },
    vendData() {
      this.vending =  true
      let obj = {
        "transaction_id": this.transactionID,
        "payment_ref": this.payment_ref,
        "payment_method": this.payment_method,
        "voucher_code": "",
      }
      obj.passcode = this.hash(this.transactionID)
      this.axios.post('https://irecharge.com.ng/api/tv/vend.php', obj)
      .then(response => {
        if(response.data.status == "0") {
          this.payment_ref = response.data.payment_ref
          this.reusable = response.data.reusable
          if(this.fields.network == 'Spectranet') {
            this.spectranetPin = response.data.pin
          }
          this.modalInstance[3].open() // transaction successful modal
          this.vending = false
          if(this.reusable == true) {
            this.modalInstance[7].open()
          }
          $('.toast').hide()
          M.toast({ html: 'Your subscription will be ACTIVE shortly.', classes: 'success' })
          this.successModal = true
          this.showSummary = false
          this.proccedBtn = false
          this.revert()
          // this.emptyFormInputs()
          this.disableFormInputs(false)
          this.updateStorage(
            this.fields.phone, 
            this.fields.email,
            this.fields.receiver
          )
        } else {
          this.successModal = false
          this.showSummary = false
          this.proccedBtn = false
          this.disableFormInputs(true)
          this.modalInstance[3].open() // transaction successful modal
          this.vending = false
          $('.toast').hide()
          M.toast({ html: response.data.message, classes: 'error' })
        }
      })
      .catch(error => {
        $('.toast').hide()
        M.toast({ html: 'Could not send request, check network.', classes: 'error' })
        this.loading = false
      })
    },
    updateStorage(phone, email, receiver) {
      var obj = {
        email: email,
        message: "Successful",
        phone: phone,
        receiver: receiver,
        service: "data",
      }
      localStorage.setItem('data', JSON.stringify(obj))
    },
    PayStack() {
      this.vending = true
      const that = this
      var value = Number(this.fields.amount) * 100
      let appkey = this.appkey_test
      if(this.mode == 2) {
        appkey = this.appkey_live
      }
      var handler = PaystackPop.setup({
        key: appkey,
        email: this.fields.email == undefined || this.fields.email == '' ? 'website@istrategytech.com' : this.fields.email,
        amount: value,
        metadata: {
          custom_fields: [{
            customer_phone: this.fields.receiver,
            customer_email: this.fields.email == undefined || this.fields.email == '' ? 'website@istrategytech.com' : this.fields.email,
            txRef: this.transactionID
          }]
        },
        callback: function(response) {
          let status = response.status, message = response.message
          if (status == "success" && message == "Approved") {
            // vend airtime now
            that.payment_ref = response.reference
            that.vendData()
          } else {
            // payment could not be completed
            that.successModal = false
            that.showSummary = false
            that.proccedBtn = false
            that.disableFormInputs(true)
            that.modalInstance[3].open()
            that.vending = false
          }
        },
        onClose: function(){
          that.emptyFormInputs()
          that.disableFormInputs(false)
          that.vending = false
        }
      });
      handler.openIframe();
    },
    revert() {
      const formInput = document.querySelector('#leftContainment')
      formInput.style.display = 'block'
      this.proccedBtn = false
      this.showSummary = false
      this.disableFormInputs(false)
    },
    ValidateData() {
      if (this.fields.network) {
        if (this.fields.service_id) {
          if (this.fields.receiver) {
            if (this.fields.phone) {
              if (this.fields.phone.toString().length === 11) {
                this.disableFormInputs(true)
                return true
              } else {
                $('.toast').hide()
                M.toast({ html: 'Phone number must be 11 characters', classes: 'info' })
              }
            } else {
              $('.toast').hide()
              M.toast({ html: 'Phone number is required!', classes: 'info' })
            }
          } else {
            $('.toast').hide()
            M.toast({ html: 'Please enter a Smart Card number!', classes: 'info' })
          }
        } else {
          $('.toast').hide()
          M.toast({ html: 'Please select a Bouquet!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'Please select a provider!', classes: 'info' })
      }
    },
    initModal() {
      // initialize modal for the document
      const option = { dismissible: false, endingTop: '6%', preventScrolling: true }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    ussdComplete() {
      this.disableFormInputs(false);
      this.revert();
      this.updateStorage(
        this.fields.phone, 
        this.fields.email,
        this.fields.receiver
      )
      this.vending = false,
      this.showSummary = false
      this.proccedBtn = false
      // this.emptyFormInputs()
    },
    emptyFormInputs() {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.value = ''
      })
      formSelect.forEach(function(item) {
        item.value = 'Select option'
      })
    },
    getImage(name) {
      return `ui/img/data/${name}.jpg`
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode);
      return encrypted.toString()
    }
  }
}
</script>

<style>
  strong {
    font-weight: 600
  }
</style>
